export default __webpack_public_path__ + "static/aid_character_problem-be948bbc549cb7da03e26050a40eeb24.svg";